
import React from "react";
import { useState } from "react";
import * as jnb from "react-bootstrap";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import Header from "../../../Header/Header";
import { CommonAxiosGet } from "../../../CommonUtils/CommonAxios/CommonAxios";
import { alertMessage } from "../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts";
export default function AloReportDashboard() {
  let navigate = useNavigate();
  const [DashboardData, setDashboardData] = useState([]);
  function GetAloDashboardData() {
    const url = `${config.url.BOC_URL}alotottaldashboard`;
    CommonAxiosGet(url).then((res) => {
      if (res.data?.status === true) {
        setDashboardData(res.data?.alodashboard);
      }
    });
  }
  useEffect(() => {
    GetAloDashboardData();
  }, []);

  return (
    <>
      <div>
        <Header />
        <div className="main_section"> </div>
            <jnb.Container>
              <jnb.Row>
                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between">
                  <div className="inner-herbpage-service-title1">
                    <h1> ALO Reports </h1>
                  </div>
                  <div className="text-right">
                  <button type="button" className="btn btn-secondary" onClick={()=>{navigate(-1)}}>Back</button>
                </div>
                </jnb.Col>
              </jnb.Row>
            </jnb.Container>
            <jnb.Container className="outer-page-content-container">
              <jnb.Row className="px-4 pt-2">
                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                  style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }} >
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>District</th>
                      <th>Total Mandals</th>
                      <th> No.Of Mandals Mapped</th>
                      <th>
                        No.Of Mandals <br />
                        Pending For Mapping
                      </th>
                      <th>No Of ACL's</th>
                      <th>No Of ALO's </th>
                    </tr>
                  </thead>
                  <tbody>
                    {DashboardData &&
                      DashboardData?.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td style={{ textAlign: "center" }}>{i + 1}</td>
                            <td>{item.distname}</td>
                            <td style={{ textAlign: "center" }}>
                              {item.mandals}
                            </td>
                            <td style={{ textAlign: "center", color: "Highlight", textDecoration: "underline" }}
                              onClick={() => { item.mapped_mandals !== 0
                                 ? navigate("/AloMappedReport",{state : {data:item}}) 
                                 : alertMessage()
                              }}>
                              {item.mapped_mandals}
                            </td>
                            <td style={{ textAlign: "center", color: "Highlight", textDecoration: "underline" }} 
                             onClick={() => { item.pending_mandals !== 0 ?
                              navigate("/AloUnMappedReport",{state : {data:item}}) 
                              : alertMessage() }}> 
                                {item.pending_mandals}
                            </td>
                            <td style={{ textAlign: "center", color: "Highlight", textDecoration: "underline" }}   onClick={() => {
                                  item.acl_count !== 0
                                    ?navigate("/ACLReport",{state : {data:item}})
                                    : alertMessage();
                                }}> {item.acl_count}                              
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.alo_count} </td>
                          </tr>
                        );
                      })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={2} style={{ textAlign: "center" }}>
                        Total
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {DashboardData.reduce((a, v) => (a = a + v.mandals), 0)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {DashboardData.reduce(
                          (a, v) => (a = a + v.mapped_mandals),
                          0
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {DashboardData.reduce(
                          (a, v) => (a = a + v.pending_mandals),
                          0
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {DashboardData.reduce(
                          (a, v) => (a = a + v.acl_count),
                          0
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {DashboardData.reduce(
                          (a, v) => (a = a + v.alo_count),
                          0
                        )}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </jnb.Row>
            </jnb.Container>
         
      </div>
    </>
  );
}
